import React, { useState, useEffect } from "react";

// Sample data
const wordPairs = [
  { arabic: "قلم", english: "Pen" },
  { arabic: "كتاب", english: "Book" },
  { arabic: "كرسي", english: "Chair" },
  { arabic: "ماء", english: "Water" },
  { arabic: "شمس", english: "Sun" },
  { arabic: "قمر", english: "Moon" },
  { arabic: "سيارة", english: "Car" },
  { arabic: "باب", english: "Door" },
  { arabic: "قطة", english: "Cat" },
  { arabic: "كلب", english: "Dog" },
  { arabic: "بيت", english: "House" },
  { arabic: "قمر", english: "Moon" },
  { arabic: "ولد", english: "Boy" },
  { arabic: "بنت", english: "Girl" },
  { arabic: "سماء", english: "Sky" },
  { arabic: "شجرة", english: "Tree" },
  { arabic: "زهرة", english: "Flower" },
  { arabic: "طائرة", english: "Airplane" },
  { arabic: "خبز", english: "Bread" },
  { arabic: "تفاحة", english: "Apple" },
  { arabic: "برتقال", english: "Orange" },
  { arabic: "لبن", english: "Milk" },
];

function shuffleArray(array) {
  return [...array].sort(() => Math.random() - 0.5);
}

function WordMatchGame() {
  const [score, setScore] = useState(0);
  const [currentWord, setCurrentWord] = useState({});
  const [options, setOptions] = useState([]);

  const generateNewRound = () => {
    const correct = wordPairs[Math.floor(Math.random() * wordPairs.length)];
    const shuffled = shuffleArray(wordPairs.filter(w => w !== correct));
    const randomOptions = shuffleArray([
      correct.english,
      ...shuffled.slice(0, 3).map(w => w.english)
    ]);

    setCurrentWord(correct);
    setOptions(randomOptions);
  };

  useEffect(() => {
    generateNewRound();
  }, []);

  const handleAnswer = (selected) => {
    if (selected === currentWord.english) {
      setScore(score + 1);
      alert("✅ Correct!");
    } else {
      alert(`❌ Wrong! It was "${currentWord.english}"`);
    }
    generateNewRound();
  };

  const speakArabic = () => {
    if (window.responsiveVoice) {
      window.responsiveVoice.speak(currentWord.arabic, "Arabic Male");
    }
  };

  return (
    <div className="p-6 md:p-10">
      <h2 className="text-3xl font-bold text-center text-blue-700 mb-6">Word Match Game</h2>
      <p className="text-xl text-center mb-8">Match the Arabic word with the correct English meaning!</p>

      <div className="mb-6 text-center">
        <h3 className="text-2xl font-semibold text-blue-600 mb-3">Score: {score}</h3>
        <div className="text-4xl text-blue-800 mb-4">{currentWord.arabic}</div>
        <button
          onClick={speakArabic}
          className="bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700 transition"
        >
          🔊 Listen
        </button>
      </div>

      <div className="grid grid-cols-2 gap-6 max-w-md mx-auto">
        {options.map((option, idx) => (
          <button
            key={idx}
            onClick={() => handleAnswer(option)}
            className="bg-white p-4 rounded-xl shadow hover:shadow-lg transition text-center text-lg border border-yellow-300 hover:bg-yellow-100"
          >
            {option}
          </button>
        ))}
      </div>
    </div>
  );
}

export default WordMatchGame;
